import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
import Exporting from "highcharts/modules/exporting.js";
import ExportData from "highcharts/modules/export-data.js";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import JobTypeDropdown from "app/components/common/JobTypeDropdown";

import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import LineChart from "app/components/charts/LineChart";
import "./IncomeLineChart.css";

HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);

const getSeriesData = (incomeData) => {
  let legendColors = ["#6AA4DC", "#FFB607", "#FF5D50"];
  let ind = -1;
  let seriesData = incomeData.map((item) => {
    ind++;
    return {
      ...item,
      color: legendColors[ind],
      showInLegend: true,
      marker: {
        symbol: "square",
      },
    };
  });
  return seriesData;
};

class IncomeLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let seriesData = getSeriesData(this.props.incomeData);
    return (
      <div className="graph-wrapper screen-left-graph-container">
        <div
          className="graph-title-container-screen graph-title-container-screen3"
          style={{ marginBottom: "20px" }}
        >
          <div className="graph-dropdown graph-dropdown-4">
            <FormControl sx={{ width: "290px", marginTop: "20px" }}>
              {/* <Typography variant="inherit" className="form-metrics-header">
                Occupation
              </Typography> */}
              <Select
                value={this.props.occupationTypeSelected}
                onChange={this.props.handleOccupationTypeChange}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                className="select-mui"
                displayEmpty
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,

                  PaperProps: {
                    sx: { maxHeight: "400px" },
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select an Occupation
                  </Typography>
                </MenuItem>
                {this.props.occupationTypes.length
                  ? this.props.occupationTypes.map((name, i) => (
                      <MenuItem key={i} value={name}>
                        <Typography variant="inherit" noWrap>
                          {name}
                        </Typography>
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </div>
          <JobTypeDropdown></JobTypeDropdown>
        </div>
        <span style={{ padding: "0px 20px 0px 50px" }}>Income Over Time</span>
        {this.props.incomeData.length != 0 &&
        this.props.incomeData[0].data.length != 0 ? (
          <LineChart
            remainingOptions={{
              chart: {
                animation: false,
                backgroundColor: "transparent",
                height: 625,
                width: 800,
                spacingTop: 0,
              },
              tooltip: {
                borderRadius: 15,
                borderWidth: 1,
                borderColor: "#707070",
                backgroundColor: "#FFFFFF",
                padding: 17,
                shape: "square",
                style: {
                  font: "Arial",
                  fontSize: 18,
                  color: "#333333",
                },
                formatter: function() {
                  return (
                    this.x +
                    "<br>" +
                    '<span style="color:' +
                    this.color +
                    '">\u25CF</span> ' +
                    this.series.name +
                    ": $" + 
                    "<b>" + Highcharts.numberFormat(this.y, 0, ".", ",") + "</b>"
                  );
                },
              },
              title: {
                text: "",
                style: {
                  color: "#FFF",
                  font: "normal normal bold 24px/28px Arial",
                },
                align: "left",
                x: 90,
              },

              xAxis: {
                gridLineWidth: 0,
                tickInterval: 2,
                title: {
                  text: "Year",
                  style: {
                    color: "#fff",
                    font: "normal normal normal 18px Arial",
                  },
                },
                labels: {
                  formatter: function() {
                    return "'" + this.value.toString().slice(-2);
                  },
                  style: {
                    color: "#fff",
                    font: "normal normal normal 18px Arial",
                  },
                },
              },

              yAxis: {
                gridLineWidth: 0.5,
                tickInterval: 8000,
                title: {
                  text: "Income",
                  style: {
                    color: "#fff",
                    font: "normal normal normal 18px Arial",
                  },
                },
                labels: {
                  formatter: function() {
                    return "$" + (this.value / 1000).toString() + "K";
                  },
                  style: {
                    color: "#fff",
                    font: "normal normal normal 18px Arial",
                  },
                },
                maxPadding: 0.2,
              },
              plotOptions: {
                series: {
                  animation: false,
                  label: {
                    connectorAllowed: false,
                  },
                  pointStart: 2005,
                },
              },
              series: seriesData,
              legend: {
                itemStyle: {
                  color: "#FFF",
                  font: "normal normal normal 16px/27px Arial",
                },
                verticalAlign: "top",
                align: "left",
                x: 80,
                backgroundColor: "transparent",
                padding: 20,
                itemMarginTop: 5,
                itemMarginBottom: 10,
                symbolRadius: 0,
                symbolHeight: 10,
              },
            }}
          />
        ) : (
          <div
            style={{
              textAlign: "center",
              paddingTop: "347px",
              height: "500px",
            }}
          >
            {" "}
            No data available{" "}
          </div>
        )}
      </div>
    );
  }
}

export default IncomeLineChart;
